import React, { useEffect, useState } from "react";
import StatCard from "../../../components/StatCard";
import {
  FaCheckCircle,
  FaUsers,
  FaExclamationTriangle,
  FaBalanceScale,
  FaArrowUp,
  FaArrowDown,
} from "react-icons/fa";

const ValidatorStats = ({ data }) => {
  const [eligibleValidatorsCount, setEligibleValidatorsCount] = useState(0);
  const [inSetValidatorsCount, setInSetValidatorsCount] = useState(0);
  const [withoutAncestryValidatorsCount, setWithoutAncestryValidatorsCount] =
    useState(0);
  const [averageBid, setAverageBid] = useState(0);
  const [maxBid, setMaxBid] = useState(0);
  const [minBid, setMinBid] = useState(0);

  useEffect(() => {
    if (data) {
      // Calculate the number of eligible validators
      const eligibleValidatorsCount = data.length;

      // Calculate the number of validators in the set
      const inSetValidatorsCount = data.filter(
        (validator) => validator.in_set
      ).length;

      // Calculate the number of validators without ancestry
      const withoutAncestryValidatorsCount = data.filter(
        (validator) => validator.ancestry.length === 0
      ).length;

      // Calculate the bids
      const bids = data
        .filter((validator) => validator.in_set)
        .map((validator) => validator.bid);
      const averageBid = bids.length
        ? Math.floor(bids.reduce((sum, bid) => sum + bid, 0) / bids.length)
        : 0;
      const maxBid = bids.length ? Math.max(...bids) : 0;
      const minBid = bids.length ? Math.min(...bids) : 0;

      // Set the state with the calculated values
      setEligibleValidatorsCount(eligibleValidatorsCount);
      setInSetValidatorsCount(inSetValidatorsCount);
      setWithoutAncestryValidatorsCount(withoutAncestryValidatorsCount);
      setAverageBid(averageBid);
      setMaxBid(maxBid);
      setMinBid(minBid);
    }
  }, [data]);

  return (
    <div className="mb-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      <StatCard
        icon={<FaCheckCircle />}
        title="Validators in Set"
        value={inSetValidatorsCount}
        color="green"
      />
      <StatCard
        icon={<FaUsers />}
        title="Eligible Validators"
        value={eligibleValidatorsCount}
        color="gray"
      />
      <StatCard
        icon={<FaExclamationTriangle />}
        title="Without Ancestry"
        value={withoutAncestryValidatorsCount}
        color="red"
      />
      <StatCard
        icon={<FaBalanceScale />}
        title="Average Bid"
        value={averageBid}
        color="blue"
      />
      <StatCard
        icon={<FaArrowUp />}
        title="Max Bid"
        value={maxBid}
        color="purple"
      />
      <StatCard
        icon={<FaArrowDown />}
        title="Min Bid"
        value={minBid}
        color="orange"
      />
    </div>
  );
};

export default ValidatorStats;
